import styled from "styled-components";
import colors from "../../theme/colors";

export const Wrapper = styled.section`
  display: grid;
  grid-template-columns: 0.9fr 1fr;
  justify-content: center;
  padding: 10px;
`;

export const ListWrapper = styled.section`
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  background-color: ${colors.dark};
  padding: 30px;
`;

export const PreviewWrapper = styled.section`
  display: grid;
  border-radius: 6px;
  padding: 30px;
  grid-template-rows: 0fr 0.7fr 1fr;
`;

export const Title = styled.h2`
  text-align: center;
  margin: 0;
  padding: 0px 0px 10px 0px;
  color: ${props => (props.ligth ? "white" : colors.dark)};
`;

export const FilterWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-bottom: 8px;
`;

export const FigureInfomationWrapper = styled.div`
  text-align: center;
`;

export const Block = styled.div`
  display: flex;
  justify-content: space-between;
  height: fit-content;
  padding: 5px 0px;
  align-items: center;
`;

export const Text = styled.p`
  font-size: 16px;
  background-color: ${props => (props.res ? "#dad8d9" : "none")};
  padding: 5px 10px;
  margin: 0 10px;
  border-radius: 6px;
  font-weight: bold;
  text-transform: capitalize;
`;

export const FilterText = styled.p`
  padding-right: 10px;
  margin: 0;
`;

export const NewDisingWrapper = styled.div`
  position: absolute;
  bottom: 20px;
  right: 30px;
  font-size: 40px;
  cursor: pointer;
`;

export const EditButton = styled.div`
  border: 2px solid white;
  background-color: ${colors.primary};
  border-color: white;
  border-radius: 25px;
  padding: 5px;
  cursor: pointer;
`;

export const Header = styled.div`
  display: grid;
  grid-template-rows: 0.1fr 1fr;
`;

export const ThreeBox = styled.section`
  height: calc(20vh);
  min-height: 200px;
  width: 100%;
`;
